export default __webpack_public_path__ + "static/media/desert.681868a9.svg";